window.shopify_vendors = [
  {
    name: 'shopify_preferences',
    title: window.axeptio_strings.preferences.title,
    shortDescription: window.axeptio_strings.preferences.description,
    policyUrl: 'https://www.shopify.com/legal/terms',
    domain: 'shopify.com',
  },
  {
    name: 'shopify_analytics',
    title: window.axeptio_strings.analytics.title,
    shortDescription: window.axeptio_strings.analytics.description,
    policyUrl: 'https://www.shopify.com/legal/terms',
    domain: 'shopify.com',
  },
  {
    name: 'shopify_marketing',
    title: window.axeptio_strings.marketing.title,
    shortDescription: window.axeptio_strings.marketing.description,
    policyUrl: 'https://www.shopify.com/legal/terms',
    domain: 'shopify.com',
  },
  {
    name: 'shopify_sale_of_data',
    title: window.axeptio_strings.sales_of_data.title,
    shortDescription: window.axeptio_strings.sales_of_data.description,
    policyUrl: 'https://www.shopify.com/legal/terms',
    domain: 'shopify.com',
  },
];

function loadAxeptio() {
  (function axeptioScript(d, s) {
    const t = d.getElementsByTagName(s)[0];
    const e = d.createElement(s);
    e.async = true;
    e.src = '//static.axept.io/sdk.js';
    t.parentNode.insertBefore(e, t);
  }(document, 'script'));

  (_axcb = window._axcb || []).push(function (sdk) {
    sdk.on("ready", function () {

      if (!sdk.cookiesConfig) {
        return;
      }

      // Construction de l'étape Shopify dans le widget de cookies
      sdk.cookiesConfig.steps.splice(1, 0, {
        disablePaint: true,
        hasVendors: true,
        layout: "category",
        message: window.axeptio_strings.welcome.message,
        name: "welcome",
        onlyOnce: true,
        title: window.axeptio_strings.welcome.title,
        subTitle: window.axeptio_strings.welcome.subtitle,
        vendors: window.shopify_vendors,
      });
    });

    // Mise à jour de l'API de consentement Shopify
    sdk.on("consent:saved", function (payload) {
      const choices = payload.consent.preferences.vendors;
      if (window.clarity) {
        window.clarity('consent', choices.shopify_analytics);
        console.log('clarity consent: ', choices.shopify_analytics);
      }
      // console.log(choices);
      window.Shopify.customerPrivacy.setTrackingConsent(
        {
          preferences: choices.shopify_preferences,
          analytics: choices.shopify_analytics,
          marketing: choices.shopify_marketing,
          sale_of_data: choices.shopify_sale_of_data,
        },
        () => { }
      );
    });
  });
}

const cookiesManagementLinks = document.querySelectorAll('a[href*="#cookies-management"]');

// API de consentement Shopify
window.Shopify.loadFeatures(
  [
    {
      name: 'consent-tracking-api',
      version: '0.1',
    },
  ],
  (error) => {
    if (error) {
      console.error(error);
    }

    if (window.clarity) {
      window.clarity('consent', window.Shopify.customerPrivacy.currentVisitorConsent().analytics === 'yes');
      console.log('clarity consent: ', window.Shopify.customerPrivacy.currentVisitorConsent().analytics === 'yes');
    }

    if (window.Shopify.customerPrivacy.shouldShowBanner()) {
      loadAxeptio();

      for (let i = 0; i < cookiesManagementLinks.length; i++) {
        cookiesManagementLinks[i].addEventListener('click', function (event) {
          event.preventDefault();
          openAxeptioCookies();
        });
      }
    } else if (cookiesManagementLinks.length) {
      // Remove Axeptio link
      for (let i = 0; i < cookiesManagementLinks.length; i++) {
        cookiesManagementLinks[i].remove();
      }
    }
  }
);